import script from "./SkillCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkillCard.vue?vue&type=script&setup=true&lang=ts"

import "./SkillCard.vue?vue&type=style&index=0&id=76f71ce9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f71ce9"]])

export default __exports__